module.exports = __webpack_public_path__ + "img/degree-uga.43bd747b.jpg";